var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fvSelect',{staticClass:"form-control select text-right fv-size-md",attrs:{"options":_vm.options,"placeholder":_vm.placeholder},model:{value:(_vm.valData),callback:function ($$v) {_vm.valData=$$v},expression:"valData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }